<template>
  <div id="building" :style="{ 'background-image': 'url(' + backImg + ')' }">
    <div>
      <table
        style="textalign: center; margin: auto"
        :style="{ marginTop: marginTop1 + 'px' }"
      >
        <tr>
          <td style="textalign: center">
            <input
              type="text"
              class="txt_userid"            
             
              :style="{ width: inputWidth + 'px' }"
              placeholder="请输入您的员工号"
              id="userid"
            />
          </td>
        </tr>
        <tr>
          <td>
            <a
              href="javascript:;"
              class="btnGo"
              :style="{ width: inputWidth + 'px' }"
              @click="goUrl"
            >
              点击进入
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

  <style scoped>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
}

#building {
  /* background-image: url("../assets/images/wjxbj3.jpg"); */
  background-position: center;
  background-repeat: no-repeat;
  /* background: url("../assets/images/wjxbj3.jpg") no-repeat center top; */
  width: 100%;
  height: 100%;
  position: fixed;
  background-size: auto 100%;
}

.txt_userid {
  
  height: 30px;
  border: 1px solid #1e30f5;
  border-radius: 10px;
  font-size: 20px;
  padding: 1px;
  box-sizing: border-box;
  color: black !important;
  margin: 1vh 0;
  outline: none;
  text-align: center;
}
.btnGo {
  background-color: #1e30f5;
  border: 1px solid #1e30f5;
  border-radius: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  font-size: 20px;
  margin-top: 15px;
}
</style>
              

<!-- 功能，直接页面跳转 -->
<script>
/* eslint-disable */
import bgMoble from "@/assets/images/wjxbj1.jpg";
import bgPC from "@/assets/images/wjxpc.jpg";
import { userOne, userTwo } from "@/userInfo.js";
//import index from "../components/Alert/index.vue";
export default {
  //components: { index },
  name: "redirectpage",
  data() {
    return {
      userid:"",
      backImg: require(`../assets/images/wjxbj1.jpg`),
      screenWidth: 1290,
      screenHeight: 463,
      marginTop1: 220,
      inputWidth: 207,
    };
  },
  mounted() {
    var txtUid = document.getElementById("userid");
    //if (this.$route.query.ticket) {
    //  this.init(this.$route.query.ticket);
    //} else {
    //  // 测试环境跳转路径 base64 编码 (https://mljy.softtekchina.com/myhomeland/redirectpage)
    //   //window.location.href = 'https://mljy.softtekchina.com/myhomeland/api/ticket?url=aHR0cHM6Ly9tbGp5LnNvZnR0ZWtjaGluYS5jb20vbXlob21lbGFuZC9yZWRpcmVjdHBhZ2Uv'
    //  // product环境跳转路径 base64 编码 (https://mljy.mdtwechat.com/myhomeland/redirectpage/)
    //  window.location.href = 'https://mljy.mdtwechat.com/myhomeland/api/ticket?url=aHR0cHM6Ly9tbGp5Lm1kdHdlY2hhdC5jb20vbXlob21lbGFuZC9yZWRpcmVjdHBhZ2Uv'
    //}

    const _this = this;
    window.screenWidth = document.documentElement.clientWidth; //实时宽度
    window.screenHeight = document.documentElement.clientHeight; //实时高度
    _this.screenWidth = window.screenWidth;
    _this.screenHeight = window.screenHeight;
    _this.marginTop1 = ((_this.screenHeight - (30 + 20 + 30)) / 2) * 1.15;
    _this.inputWidth = parseInt(((window.screenHeight * 75) / 134) * 0.8);
console.log('screenWidth:'+window.screenWidth)
console.log('screenHeight:'+window.screenHeight)
console.log('marginTop1:'+_this.marginTop1)
console.log('inputWidth:'+_this.inputWidth)
    window.onresize = function windowResize() {
      window.screenWidth = document.documentElement.clientWidth; //实时宽度
      window.screenHeight = document.documentElement.clientHeight; //实时高度
      _this.screenWidth = window.screenWidth;
      _this.screenHeight = window.screenHeight;
      _this.marginTop1 = ((_this.screenHeight - (30 + 20 + 30)) / 2) * 1.15;
      _this.inputWidth = parseInt(((window.screenHeight * 75) / 134) * 0.8);
     
    };
  },

  methods: {
    //async init(ticket) {
    //  await getUserInfoMsg(ticket);
    //},
    
    goUrl: function () {
      const userid = document.getElementById("userid").value;
      if (userid == "" || userid == null) {
        return;
      }
      

      const fl = this.userMatch(userid);

      if (fl == "1") {
        //匹配上IDL用户组 全员必知无需输入员工号
        window.location.href = "https://qywx.wjx.cn/vj/hDnYMDk.aspx";
      } else if (fl == "2") {
        //匹配上DL用户组 DL必知海选
        window.location.href = "https://qywx.wjx.cn/vj/QFa6FSw.aspx";
      } else {
        window.location.href = "https://qywx.wjx.cn/vj/hDnYMDk.aspx";
      }
    },
    userMatch: function (userid) {
      const user1 = userOne; //全员
      const user2 = userTwo; //DL问卷
      if (userid == "" || userid == null) {
        return "-1";
      }

      // 存在0，不存在-1
      if (user1.indexOf(userid) != -1) {
        // 全员问卷

        return "1";
      } else if (user2.indexOf(userid) != -1) {
        // DL问卷

        return "2";
      } else {
        return "0";
      }
    },
  },
};
</script>
